import React from 'react';
import clsx from 'clsx';
import styles from './ResponsiveContainer.module.scss';

const ResponsiveContainer = ({
  type = 'inline-size',
  name,
  as: Component = 'div',
  children,
  ...theRestOfTheProps
}) => {
  const className = clsx(
    styles.ResponsiveContainer
  );

  const style = {
    containerType: type !== 'normal' ? type : undefined,
    containerName: name || undefined,
  };

  return (
    <Component
      className={clsx(styles.container, className)}
      style={style}
      {...theRestOfTheProps}
    >
      {children}
    </Component>
  );
};

export default ResponsiveContainer;
